function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { extend } from "../utils/extend.js";
import { resolve } from "../utils/resolve.js";
import { isPlainObject } from "../utils/isPlainObject.js";
/**
 * Base class, all components inherit from this class
 */

export var Base = /*#__PURE__*/function () {
  /**
   * Base constructor
   * @param {Object} [options] - Options as `key: value` pairs
   */
  function Base() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Base);

    this.options = extend(true, {}, options);
    this.plugins = [];
    this.events = {}; // * Prefill with initial events

    for (var _i = 0, _arr = ["on", "once"]; _i < _arr.length; _i++) {
      var type = _arr[_i];

      for (var _i2 = 0, _Object$entries = Object.entries(this.options[type] || {}); _i2 < _Object$entries.length; _i2++) {
        var args = _Object$entries[_i2];
        this[type].apply(this, _toConsumableArray(args));
      }
    }
  }
  /**
   * Retrieve option value by key, supports subkeys
   * @param {String} key Option name
   * @param {*} [fallback] Fallback value for non-existing key
   * @returns {*}
   */


  _createClass(Base, [{
    key: "option",
    value: function option(key, fallback) {
      // Make sure it is string
      key = String(key);
      var value = resolve(key, this.options); // Allow to have functions as options

      if (typeof value === "function") {
        var _value;

        for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          rest[_key - 2] = arguments[_key];
        }

        value = (_value = value).call.apply(_value, [this, this].concat(rest));
      }

      return value === undefined ? fallback : value;
    }
    /**
     * Simple l10n support - replaces object keys
     * found in template with corresponding values
     * @param {String} str String containing values to localize
     * @param {Array} params Substitute parameters
     * @returns {String}
     */

  }, {
    key: "localize",
    value: function localize(str) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      str = String(str).replace(/\{\{(\w+).?(\w+)?\}\}/g, function (match, key, subkey) {
        var rez = ""; // Plugins have `Plugin.l10n.KEY`

        if (subkey) {
          rez = _this.option("".concat(key[0] + key.toLowerCase().substring(1), ".l10n.").concat(subkey));
        } else if (key) {
          rez = _this.option("l10n.".concat(key));
        }

        if (!rez) {
          rez = match;
        }

        for (var index = 0; index < params.length; index++) {
          rez = rez.split(params[index][0]).join(params[index][1]);
        }

        return rez;
      });
      str = str.replace(/\{\{(.*)\}\}/, function (match, key) {
        return key;
      });
      return str;
    }
    /**
     * Subscribe to an event
     * @param {String} name
     * @param {Function} callback
     * @returns {Object}
     */

  }, {
    key: "on",
    value: function on(name, callback) {
      var _this2 = this;

      if (isPlainObject(name)) {
        for (var _i3 = 0, _Object$entries2 = Object.entries(name); _i3 < _Object$entries2.length; _i3++) {
          var args = _Object$entries2[_i3];
          this.on.apply(this, _toConsumableArray(args));
        }

        return this;
      }

      String(name).split(" ").forEach(function (item) {
        var listeners = _this2.events[item] = _this2.events[item] || [];

        if (listeners.indexOf(callback) == -1) {
          listeners.push(callback);
        }
      });
      return this;
    }
    /**
     * Subscribe to an event only once
     * @param {String} name
     * @param {Function} callback
     * @returns {Object}
     */

  }, {
    key: "once",
    value: function once(name, callback) {
      var _this3 = this;

      if (isPlainObject(name)) {
        for (var _i4 = 0, _Object$entries3 = Object.entries(name); _i4 < _Object$entries3.length; _i4++) {
          var args = _Object$entries3[_i4];
          this.once.apply(this, _toConsumableArray(args));
        }

        return this;
      }

      String(name).split(" ").forEach(function (item) {
        var listener = function listener() {
          _this3.off(item, listener);

          for (var _len2 = arguments.length, details = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            details[_key2] = arguments[_key2];
          }

          callback.call.apply(callback, [_this3, _this3].concat(details));
        };

        listener._ = callback;

        _this3.on(item, listener);
      });
      return this;
    }
    /**
     * Unsubscribe event with name and callback
     * @param {String} name
     * @param {Function} callback
     * @returns {Object}
     */

  }, {
    key: "off",
    value: function off(name, callback) {
      var _this4 = this;

      if (isPlainObject(name)) {
        for (var _i5 = 0, _Object$entries4 = Object.entries(name); _i5 < _Object$entries4.length; _i5++) {
          var args = _Object$entries4[_i5];
          this.off.apply(this, _toConsumableArray(args));
        }

        return;
      }

      name.split(" ").forEach(function (item) {
        var listeners = _this4.events[item];

        if (!listeners || !listeners.length) {
          return _this4;
        }

        var index = -1;

        for (var i = 0, len = listeners.length; i < len; i++) {
          var listener = listeners[i];

          if (listener && (listener === callback || listener._ === callback)) {
            index = i;
            break;
          }
        }

        if (index != -1) {
          listeners.splice(index, 1);
        }
      });
      return this;
    }
    /**
     * Emit an event.
     * If present, `"*"` handlers are invoked after name-matched handlers.
     * @param {String} name
     * @param  {...any} details
     * @returns {Boolean}
     */

  }, {
    key: "trigger",
    value: function trigger(name) {
      for (var _len3 = arguments.length, details = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        details[_key3 - 1] = arguments[_key3];
      }

      var _iterator = _createForOfIteratorHelper(_toConsumableArray(this.events[name] || []).slice()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var listener = _step.value;

          if (listener && listener.call.apply(listener, [this, this].concat(details)) === false) {
            return false;
          }
        } // A wildcard "*" event type

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(_toConsumableArray(this.events["*"] || []).slice()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _listener = _step2.value;

          if (_listener && _listener.call.apply(_listener, [this, name, this].concat(details)) === false) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return true;
    }
    /**
     * Add given plugins to this instance,
     * this will end up calling `attach` method of each plugin
     * @param {Object} Plugins
     * @returns {Object}
     */

  }, {
    key: "attachPlugins",
    value: function attachPlugins(plugins) {
      var newPlugins = {};

      for (var _i6 = 0, _Object$entries5 = Object.entries(plugins || {}); _i6 < _Object$entries5.length; _i6++) {
        var _ref3 = _Object$entries5[_i6];

        var _ref2 = _slicedToArray(_ref3, 2);

        var key = _ref2[0];
        var Plugin = _ref2[1];

        // Check if this plugin is not disabled by option
        if (this.options[key] !== false && !this.plugins[key]) {
          // Populate options with defaults from the plugin
          this.options[key] = extend({}, Plugin.defaults || {}, this.options[key]); // Initialise plugin

          newPlugins[key] = new Plugin(this);
        }
      }

      for (var _i7 = 0, _Object$entries6 = Object.entries(newPlugins); _i7 < _Object$entries6.length; _i7++) {
        var _ref6 = _Object$entries6[_i7];

        var _ref5 = _slicedToArray(_ref6, 2);

        var _key4 = _ref5[0];
        var plugin = _ref5[1];
        plugin.attach(this);
      }

      this.plugins = Object.assign({}, this.plugins, newPlugins);
      return this;
    }
    /**
     * Remove all plugin instances from this instance,
     * this will end up calling `detach` method of each plugin
     * @returns {Object}
     */

  }, {
    key: "detachPlugins",
    value: function detachPlugins() {
      for (var key in this.plugins) {
        var plugin = void 0;

        if ((plugin = this.plugins[key]) && typeof plugin.detach === "function") {
          plugin.detach(this);
        }
      }

      this.plugins = {};
      return this;
    }
  }]);

  return Base;
}();